/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : order-history-api.ts
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Oct 26 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On            : Nov, 5 2020
* Description   : ASDS-4016 UI Enhancements for Phase-II
*
******************************************************************************/

import { CheckoutServiceURL } from '../constants/checkout-constants';
import API from './api';
import { logError } from '../../../utils/console-utility';

class OrderHistoryDetails {
  static async getOrderHistory(soldTo: string) {
    const orderSummaryURL = `${CheckoutServiceURL.ORDER_HISTORY_URL}`;
    const response = await API.get(
      `${orderSummaryURL}?view=order&soldTos=${soldTo}`
    ).catch(error => {
      logError('Error fetching and parsing data - order history ', error);
    });
    return response ? response.data : {};
  }

  static async downloadOrderInvoice(invoiceNo: string, system: string) {
    const orderSummaryURL = `${CheckoutServiceURL.INVOICE_URL}`;
    const response = await API.get(
      `${orderSummaryURL}/${invoiceNo}/documents?system=${system.toLowerCase()}&type=pdf`
    ).catch(error => {
      logError('Error fetching and parsing data - order history ', error);
      return error;
    });
    return response ? response.data : {};
  }

  static async getOrderHistoryWithFilters(soldTo: string, status: string, fromDate: string, toDate: string) {
    const orderSummaryURL = `${CheckoutServiceURL.ORDER_HISTORY_URL}`;
    const response = await API.get(
      `${orderSummaryURL}?view=order&soldTos=${soldTo}`
        + ((fromDate !== '' && toDate !== '') ? `&fromOrderDate=${fromDate}&toOrderDate=${toDate}` : '')
        + (status !== '' ? `&status=${status}` : '')
    ).catch(error => {
      logError('Error fetching and parsing data - order history ', error);
    });
    return response ? response.data : {};
  }
}

export default OrderHistoryDetails;